<template>
  <div class="pa-3">
    <v-row>
      <v-col cols="12">
        <!-- Reload button -->
        <v-btn color="warning" small @click.stop="paginate(1, true)">
          <v-icon left>
            mdi-cached
          </v-icon>
          Reload
        </v-btn>
        <v-btn color="warning" @click="download()" small>
          <v-icon color="white" small>download</v-icon> Export Excel
        </v-btn>
        <!-- Reset button -->
        <!-- <v-btn color="default" small @click.stop="paginate(1, true)">
          <v-icon left>
            mdi-cached
          </v-icon>
          Reset Filters
        </v-btn> -->
      </v-col>
      <v-col cols="12" v-if="showSummaryPerson || showFilterDate">
        <v-card-title class="sub-title ma-0 pa-0">Score {{showSummaryPerson}} {{showFilterDate}} 
          <!-- <v-btn class="ml-2" color="warning" icon small @click.stop="paginate(1, true)">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn> -->
        </v-card-title>
      </v-col>
      <v-col cols="12" v-else>
        <v-card-title class="sub-title ma-0 pa-0">
          Score for Entire team
        </v-card-title>
      </v-col>
    </v-row>
    <v-layout row wrap class="mt-0">
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">NPS Score</v-card-title>
          <v-card-text>
            <h3>{{totalValues.recommended}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3 v-if="showCCBox">
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Creator line up</v-card-title>
          <v-card-text>
            <h3>{{totalValues.creatorLineup}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3 v-if="showCCBox">
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Creator content created</v-card-title>
          <v-card-text>
            <h3>{{totalValues.contentCreated}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3 v-if="showAMBox">
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">AM Score</v-card-title>
          <v-card-text>
            <h3>{{totalValues.amScore}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <div>
      <p class="subtitle-1 mb-0">
        <v-icon small color="secondary" style="margin-top:-3px;">mdi-alert-circle-outline</v-icon> All points are calculated by 10
      </p>
    </div>
    <v-row class="mt-0">
      <v-col cols="12" class="pt-0">
        <v-card-title class="pt-0 pl-0">
          <v-col class="pb-0 pl-0" cols="2">
            <div v-if="isArchive">
              <v-btn
              color="success"
              class="mt-3"
              small
              v-if="selectedForms.length > 0"
              @click="restoreArchive">
                <v-icon small>mdi-restore</v-icon> Restore
              </v-btn>
            </div>
            <div v-if="!isArchive && isSuperAdmin">
              <v-btn
              color="warning"
              class="mt-3"
              small
              v-if="selectedForms.length > 0"
              @click="archiveFeedbackForm">
                <v-icon small>mdi-archive</v-icon> Archive
              </v-btn>
            </div>
          </v-col>
          <v-col class="pb-0" cols="10">
            <v-col class="pb-0" cols="12" sm="12" md="2" lg="2">
              <v-select
                :items="NPSFilters"
                item-value="value"
                item-text="text"
                label="NPS Score"
                v-model="selectedFilter.NPS"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-select>
            </v-col>
            <v-col class="pb-0" cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="AM"
                item-value="id"
                item-text="name"
                label="AM"
                v-model="selectedFilter.AM"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col class="pb-0" cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="CO"
                item-value="id"
                item-text="name"
                label="CC"
                v-model="selectedFilter.CO"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col class="pb-0" cols="12" sm="12" md="2" lg="2">
              <v-menu
                ref="submittedDatePicker"
                v-model="submittedDateCal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                dense
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="Month Range"
                    placeholder="Month Range"
                    v-model="selectedFilter.submittedDate"
                    dense
                    readonly
                    clearable
                    outlined
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    @change="searchFilter"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedFilter.submittedDate"
                  type="month"
                  no-title
                  scrollable
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="secondary"
                      @click="cancelMonth()"
                  >
                      Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="secondary"
                      @click="searchMonthOk()"
                  >
                      OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="pb-0" cols="12" sm="12" md="2" lg="2">
              <v-select
                style="max-width:200px;"
                :items="defaultYears"
                label="Year"
                v-model="selectedFilter.year"
                outlined
                dense
                hide-details
                @change="searchFilter"
              ></v-select>
            </v-col>
            <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-col>
        </v-card-title>

        <!-- BEGIN vue data table -->
        <v-data-table
        ref="feedbackForm"
        :headers="headers"
        :search="filter"
        :items="filteredItems"
        show-select
        @toggle-select-all="selectAllForms"
        @current-items="currentItems"
        :single-select="false"
        v-model="selectedForms"
        class="elevation-1">
          <template v-slot:[`item.likely_recommend`]="{ item }">
            <v-layout row class="text-center">
              <v-flex class="rating-num">
                {{item.likely_recommend}} / 10
              </v-flex>
            </v-layout>
          </template>
          <template v-slot:[`item.likely_consider_again`]="{ item }">
            <v-layout row class="text-center">
              <v-flex class="rating-num">
                {{item.likely_consider_again}} / 10
              </v-flex>
            </v-layout>
          </template>
          <template v-slot:[`item.infLineUpIdx`]="{ item }">
            <v-layout row class="text-center">
              <v-flex class="rating-num">
                {{item.infLineUpIdx}} / 4
              </v-flex>
            </v-layout>
          </template>
          <template v-slot:[`item.infContentCreatedIdx`]="{ item }">
            <v-layout row class="text-center">
              <v-flex class="rating-num">
                {{item.infContentCreatedIdx}} / 4
              </v-flex>
            </v-layout>
          </template>
          <template v-slot:[`item.amScore`]="{ item }">
            <v-layout row class="text-center">
              <v-flex class="rating-num">
                {{item.amScore}} / 12
              </v-flex>
            </v-layout>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td class="justify-center layout px-0">
              <!-- View Button -->
              <v-btn @click="getFeedbackDataToView(item)" color="info" class="ims-action">
                <v-icon small data-toggle="tooltip" data-placement="top" title="View Campaign">remove_red_eye</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>No Data</template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- ViewFeedback modal -->
    <view-feedback-modal v-model="viewModalDialog" :value="viewModalDialog" :feedbackData="viewFeedbackData" />
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ViewFeedbackModal from './ViewFeedbackModal';
import campaignAPIs from '../Campaign/campaignAPIs';
import clientAPIs from './clientAPIs'
import userAPIs from '../User/userAPIs';
import config from '@/config';
import clientConfig from './clientConfig.js';
import moment from 'moment';
import utils from '../../../utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'FeedbacksForm',
  components: {
    ViewFeedbackModal,
    Loading
  },
  data() {
    return {
      feedbackFormSections: clientConfig.feedbackFormSections,
      viewFeedbackData: null,
      viewModalDialog: false,
      allClients: [],
      allClientUsers: [],
      AM: [],
      CO: [],
      defaultYears: [2026, 2025, 2024, 2023, 2022],
      NPSFilters: [
        {
          text: 'All',
          value: 0
        },
        {
          text: '>= 9 NPS Score',
          value: 1
        }
      ],
      selectedFilter: {
        NPS: 0,
        AM: '',
        CO: '',
        submittedDate: [],
        year: 2026
      },
      allCampaigns: [],
      headers: [
        {
          text: 'Campaign Name',
          value: 'campaignName'
        },
        {
          text: 'Billing Name as per Xero',
          value: 'clientName'
        },
        {
          text: 'Account Manager',
          value: 'accountManager'
        },
        {
          text: 'Content & Community Curator',
          value: 'CO'
        },
        {
          text: 'NPS Score',
          value: 'likely_recommend'
        },
        {
          text: 'Creator line up',
          value: 'infLineUpIdx'
        },
        {
          text: 'Creator content created',
          value: 'infContentCreatedIdx'
        },
        {
          text: 'AM Score',
          value: 'amScore'
        },
        {
          text: 'Submitter Name',
          value: 'name'
        },
        {
          text: 'Submitter Email',
          value: 'email'
        },
        {
          text: 'Submitted Date',
          value: 'updatedAtDisplay'
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      items: [],
      filteredItems: [],
      selectedForms: [],
      pagination: {
        rowsPerPage: 15
      },
      totalValues: {
        recommended: 0,
        creatorLineup: 0,
        contentCreated: 0,
        amScore: 0
      },
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      filter: '',
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      feedbackFormUpdated: state => state.campaign.feedbackFormUpdated
    }),
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    isSuperAdmin: function () {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH
    },
    isArchive: function () {
      return this.$route.meta.archive || false;
    },
    showSummaryPerson: function () {
      let respNames = []
      let respStr = ''
      if (this.selectedFilter.AM) {
        let matchAM = this.AM.find(a => a.id === this.selectedFilter.AM)
        if (matchAM) {
          respNames.push(matchAM.name)
        }
      }
      if (this.selectedFilter.CO) {
        let matchCO = this.CO.find(a => a.id === this.selectedFilter.CO)
        if (matchCO) {
          respNames.push(matchCO.name)
        }
      }
      if (respNames.length) {
        respStr += 'for '
      }
      respStr += respNames.join(', ')
      return respStr
    },
    showFilterDate: function () {
      if (this.selectedFilter.submittedDate && this.selectedFilter.submittedDate.length) {
        let respDateStr = 'in '
        respDateStr += utils.func.formatCustomDate(this.selectedFilter.submittedDate[0], 'MMM YYYY')
        if (this.selectedFilter.submittedDate.length > 1) {
          respDateStr += ` - ${utils.func.formatCustomDate(this.selectedFilter.submittedDate[1], 'MMM YYYY')}`
        }
        return respDateStr
      }
      return ''
    },
    showCCBox() {
      return !this.selectedFilter.AM || this.selectedFilter.CO || (!this.selectedFilter.AM && !this.selectedFilter.CO)
    },
    showAMBox() {
      return !this.selectedFilter.CO || this.selectedFilter.AM || (!this.selectedFilter.AM && !this.selectedFilter.CO)
    }
  },
  watch: {
    currentPage() {
      this.paginate(this.currentPage)
    },
    allClients: {
      handler(value) {
        this.paginate(this.currentPage)
      }
    },
    AM: {
      handler(value) {
        this.paginate(this.currentPage)
      }
    }
  },
  methods: {
    updateItems(response) {
      let infLineUp = this.feedbackFormSections.inf_line_up.values
      let infContentCreated = this.feedbackFormSections.inf_content_created.values
      let feedbacks = response.feedbacks
      feedbacks = feedbacks.map(item => {
        item.updatedAtDisplay = utils.func.formatCustomDate(item.createdAt, 'DD/MM/YYYY')
        item.clientName = this.getClientName(item.clientID)
        item.accountManager = this.getAMName(item.amID)
        if (item.coID) {
          item.CO = this.getCOName(item.coID)
        }
        item.infLineUpIdx = infLineUp.findIndex(f => f === item.inf_line_up)
        item.infContentCreatedIdx = infContentCreated.findIndex(f => f === item.inf_content_created)
        if (item.infLineUpIdx >= 0) {
          item.infLineUpIdx = item.infLineUpIdx + 1
        } else {
          item.infLineUpIdx = 0
        }
        if (item.infContentCreatedIdx >= 0) {
          item.infContentCreatedIdx = item.infContentCreatedIdx + 1
        } else {
          item.infContentCreatedIdx = 0
        }
        item.amScore = (item.dependable || 0) + (item.initiative || 0) + (item.knowledgeable || 0)
        return item
      });
      this.items = feedbacks
      this.totalRows = response.totalFeedbacks
      this.searchFilter()
    },
    paginate(page = 1, reload = false) {
      this.resetFilter()
      this.currentPage = page
      campaignAPIs
        .getClientFeedbacks({
          page: page,
          keyword: this.filter,
          archive: this.isArchive,
          sort: 'updatedAt DESC'
        })
        .then(response => {
          this.updateItems(response)
          if (!reload) {
            this.loadFeedbackFormByURL()
          }
        })
        .catch(error => {
          console.log('error', error)
        });
    },
    searchFilter() {
      this.filteredItems = this.items.map(i => i)
      if (this.selectedFilter.NPS) {
        this.filteredItems = this.filteredItems.filter(item => item.likely_recommend >= 9)
      }
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(item => item.amID === this.selectedFilter.AM)
      }
      if (this.selectedFilter.CO) {
        this.filteredItems = this.filteredItems.filter(item => item.coID === this.selectedFilter.CO)
      }
      if (this.selectedFilter.year) {
        this.filteredItems = this.filteredItems.filter(item => {
          const createdYear = utils.func.formatCustomDate(item.createdAt, 'YYYY')
          return Number(createdYear) === Number(this.selectedFilter.year)
        })
      }
      if (this.selectedFilter.submittedDate && this.selectedFilter.submittedDate.length) {
        // filter by date range
        let dates = this.selectedFilter.submittedDate
        this.filteredItems = this.filteredItems.filter(item => {
          const createdMonth = utils.func.formatCustomDate(item.createdAt, 'YYYY-MM')
          if (dates.length === 1) {
            return createdMonth === this.selectedFilter.submittedDate[0]
          } else if (dates.length === 2) {
            return createdMonth >= dates[0] && createdMonth <= dates[1]
          }
          return false
        })
      }
      this.calTotalSummary()
    },
    calTotalSummary(customItems = []) {
      this.totalValues = {
        recommended: 0,
        creatorLineup: 0,
        contentCreated: 0,
        amScore: 0
      }
      let calcItems = []
      if (customItems.length) {
        calcItems = Object.assign([], customItems)
      } else {
        calcItems = Object.assign([], this.filteredItems)
      }
      let totalItems = calcItems.length
      if (!totalItems) return // if no results, skip calc
      let recommend = 0
      let creatorLineup = 0
      let contentCreated = 0
      let amScore = 0
      calcItems.map(f => {
        if (f.likely_recommend) recommend += parseFloat(f.likely_recommend || 0)
        if (f.infLineUpIdx) creatorLineup += parseFloat(f.infLineUpIdx || 0)
        if (f.infContentCreatedIdx) contentCreated += parseFloat(f.infContentCreatedIdx || 0)
        if (f.amScore) amScore += parseFloat(f.amScore || 0)
        return f
      })
      let totalRecommended = calcItems.filter(c => c.likely_recommend).length
      let totalLineUp = calcItems.filter(c => c.infLineUpIdx).length
      let totalContentCreated = calcItems.filter(c => c.infContentCreatedIdx).length
      let totalAMScore = calcItems.filter(c => c.amScore).length
      // calc avg values
      this.totalValues.recommended = (recommend / totalRecommended).toFixed(2)
      this.totalValues.creatorLineup = ((creatorLineup / totalLineUp) * 2.5).toFixed(2)
      this.totalValues.contentCreated = ((contentCreated / totalContentCreated) * 2.5).toFixed(2)
      this.totalValues.amScore = (((amScore / totalAMScore) / 12) * 10).toFixed(2)
    },
    resetFilter() {
      this.selectedFilter = {
        NPS: 0,
        AM: '',
        CO: '',
        submittedDate: [],
        year: 2026
      }
      this.selectedForms = []
      this.searchFilter()
    },
    getClientName(id) {
      let result = null;
      this.allClients.forEach(item => {
        if (item.id === id) {
          if (item.group) {
            result = item.group.Name || item.name
          } else {
            result = item.name
          }
        }
      });
      return result;
    },
    getClientFullName(id) {
      let result = null;
      this.allClientUsers.forEach(item => {
        if (item.id === id) {
          let clientName = this.getClientName(item.clientID)
          result = `${item.firstName} ${item.lastName} (${clientName})`
        }
      });
      return result;
    },
    getCampaignName(id) {
      let result = null;
      this.allCampaigns.forEach(item => {
        if (item.id === id) {
          result = item.name
        }
      });
      return result;
    },
    getAMName(id) {
      let result = null;
      this.AM.forEach(item => {
        if (item.id === id) {
          result = `${item.firstName} ${item.lastName}`
        }
      });
      return result;
    },
    getCOName(id) {
      let result = null;
      this.CO.forEach(item => {
        if (item.id === id) {
          result = `${item.firstName} ${item.lastName}`
        }
      });
      return result;
    },
    formatTime(value) {
      return moment(value).fromNow();
    },
    getFeedbackDataToView(viewData) {
      this.viewFeedbackData = viewData
      this.viewModalDialog = true
    },
    loadFeedbackFormByURL() {
      let feedbackFormID = this.$route.query.id;
      if (feedbackFormID) {
        let formOne = this.items.find(i => i.id === feedbackFormID)
        if (formOne) {
          this.getFeedbackDataToView(formOne)
        }
      }
    },
    selectAllForms($event) {
      if (($event.value && $event.items.length === 0) || !$event.value) {
        this.selectedForms = [];
        return;
      }
      if (this.selectedForms.length === 0) {
        this.selectedForms = $event.items
      } else this.selectedForms = []
    },
    currentItems() {
      this.$nextTick(() => {
        this.calTotalSummary(this.$refs.feedbackForm.$children[0].filteredItems)
      });
    },
    restoreArchive() {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to restore?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let ids = this.selectedForms.map(item => item.id)
          let data = ids.map(feedbackFormID => {
            return Object.assign({}, {
              id: feedbackFormID,
              archive: false
            })
          })
          // Submit request to save archived client feedback form data
          this.isLoading = true;
          await this.$store.dispatch('campaign/updateFeedbackFormByIds', data)
          this.isLoading = false;
          if (!this.feedbackFormUpdated) {
            this.$swal({
              text: 'Error Restoring Feedback Forms.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully Restored.',
            type: 'success'
          });
          this.paginate(1, true)
        }
      })
    },
    archiveFeedbackForm() {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to archive?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let ids = this.selectedForms.map(item => item.id)
          let data = ids.map(feedbackFormID => {
            return Object.assign({}, {
              id: feedbackFormID,
              archive: true
            })
          })
          // Submit request to save archived client feedback form data
          this.isLoading = true;
          await this.$store.dispatch('campaign/updateFeedbackFormByIds', data)
          this.isLoading = false;
          if (!this.feedbackFormUpdated) {
            this.$swal({
              text: 'Error Archiving Feedback Forms.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully Archived.',
            type: 'success'
          });
          this.paginate(1, true)
        }
      })
    },
    async cancelMonth() {
      this.submittedDateCal = false
      this.selectedFilter.submittedDate = []
      this.searchFilter()
    },
    searchMonthOk() {
      this.submittedDateCal = false
      this.searchFilter()
    },
    download() {
      this.isLoading = true
      let feedbackIds = this.filteredItems.map(i => i.id)
      let data = {
        feedbackIds
      }
      campaignAPIs
        .downloadClientFeedback(data)
        .then(() => {
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log('error in downloading client feedback report', error);
        });
    }
  },
  mounted() {
    this.paginate(1);
    // get Client Lists
    if (
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.ACCOUNT_MANAGER ||
      this.currentUserRole === config.userRoles.AD_STRATEGIST
    ) {
      clientAPIs
      .getAllClients(false)
      .then(response => {
        this.allClients = response.data
      })
      .catch(error => {
        // Request failed.
        console.log('error', error)
      });

      userAPIs
        .getAllUsersByRole(config.userRoles.CLIENT)
        .then(response => {
          this.allClientUsers = response.users
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        });

      userAPIs
      .getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      .then(response => {
        this.AM = response.users
        this.AM = this.AM.map(am => {
          am.name = `${am.firstName} ${am.lastName}`
          return am
        })
        this.AM.unshift({id: '', name: 'All Team'})
      })
      .catch(error => {
        console.log('error', error)
      });

      userAPIs
      .getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      .then(response => {
        this.CO = response.users
        this.CO = this.CO.map(cc => {
          cc.name = `${cc.firstName} ${cc.lastName}`
          return cc
        })
        this.CO.unshift({id: '', name: 'All Team'})
      })
      .catch(error => {
        console.log('error', error)
      });
    }

    if (this.currentUserRole === config.userRoles.CLIENT) {
      this.checkForVendorFormComplete()
    }
  }
}
</script>
<style scoped>
  .card-title {
    min-height: 75px;
    padding-bottom: 0;
  }
  .card-title.one-line {
    padding-top: 0;
  }
  .rating-num {
    font-size: 15px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// FeedbacksForm.vue?d8f0c38c